import React, { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Approaches.css";
import { TbTargetArrow } from "react-icons/tb";
//
import ASSETS from "../../../../app/config/assets";
//
import { FaPeopleLine, FaPeopleRoof } from "react-icons/fa6";
import { IoMdCheckboxOutline } from "react-icons/io";
import { GiTeacher } from "react-icons/gi";

gsap.registerPlugin(ScrollTrigger);

const Approaches = () => {
  const containerRef = useRef();
  const horizontalRef = useRef();

  useLayoutEffect(() => {
    if (window.innerWidth <= 991) return;

    const element = containerRef.current;
    const horizontalSection = horizontalRef.current;

    const totalScrollWidth = horizontalSection.scrollWidth;
    const viewportWidth = containerRef.current.offsetWidth;
    const scrollDistance = totalScrollWidth - viewportWidth;

    gsap.to(horizontalSection, {
      x: () => `-${scrollDistance}px`,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top top",
        end: () => `+=${scrollDistance}`,
        scrub: true,
        pin: true,
        anticipatePin: 1,
      },
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <div className="h-social-learning">
      <div className="h-social-learning-container" ref={containerRef}>
        <div className="h-social-learning-features" ref={horizontalRef}>
          <div className="social-learning-item">
            <img src={ASSETS?.for_pupils} alt="for pupils" className="img" />
            <div className="text-wrapper">
              <h2>
                Driven by the mission of providing high-quality educational
                content grounded in best pedagogical practices to reduce
                inequalities, <span>MASOMO</span> is designed for :
              </h2>
              <div className="tick">
                <FaPeopleLine className="icon" />
                <h1>Pupils</h1>
              </div>
              <div className="duties">
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Learning wherever you are</span>
                </div>
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Study at your own pace, even offline.</span>
                </div>
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Review lessons and prepare for quizzes and exams.</span>
                </div>
              </div>
            </div>
          </div>
          <div className="social-learning-item">
            <div className="text-wrapper">
              <h2>
                Driven by the mission of providing high-quality educational
                content grounded in best pedagogical practices to reduce
                inequalities, <span>MASOMO</span> is designed for :
              </h2>
              <div className="tick">
                <FaPeopleRoof className="icon" />
                <h1>Parents</h1>
              </div>
              <div className="duties">
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Helping their childrens with review and/or prepare for assessments</span>
                </div>
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Following the progress of their childrens</span>
                </div>
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Assess their children with challenges</span>
                </div>
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Learning at their own pace</span>
                </div>
              </div>
            </div>
            <img src={ASSETS?.for_parents} alt="for parents" className="img" />
          </div>
          <div className="social-learning-item">
            <img
              src={ASSETS?.for_lecturers}
              alt="for lecturers"
              className="img"
            />
            <div className="text-wrapper">
              <h2>
                Driven by the mission of providing high-quality educational
                content grounded in best pedagogical practices to reduce
                inequalities, <span>MASOMO</span> is designed for :
              </h2>
              <div className="tick">
                <GiTeacher className="icon" />
                <h1>Teachers and Lectures</h1>
              </div>
              <div className="duties">
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Access high-quality educational content and learning materials.</span>
                </div>
                <div className="duty-row">
                  <IoMdCheckboxOutline className="icon" />
                  <span>Plan and prepare lessons for teaching</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approaches;
